'use client';

import type { Point, Polygon } from './types';

/**
 * @description Check if a point is inside a polygon
 * @see https://en.wikipedia.org/wiki/Point_in_polygon#Ray_casting_algorithm
 */
export function isPointInPolygon({ x, y }: Point, polygon: Polygon): boolean {
  return polygon.reduce((inside, { x: xi, y: yi }, i) => {
    // calculate the previous point in the polygon
    const { x: xj, y: yj } = polygon[(i + polygon.length - 1) % polygon.length];
    // check if the ray intersects with the polygon edge
    // prettier-ignore
    const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    // if the ray intersects with the polygon edge, toggle the inside flag
    return intersect ? !inside : inside;
  }, false);
}
